export default __webpack_public_path__ + "static/media/JobThree4.d3276830.JPG";